module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product7-693d5d247894051b9963c2bb0ca0d47b.jpg";